/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VisitsRouteImport } from './routes/visits'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as QaRouteImport } from './routes/qa'
import { Route as ProvidersRouteImport } from './routes/providers'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PatientsIndexRouteImport } from './routes/patients/index'
import { Route as PatientsPatientIdRouteImport } from './routes/patients/$patientId'

const VisitsRoute = VisitsRouteImport.update({
  id: '/visits',
  path: '/visits',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsRoute = ReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const QaRoute = QaRouteImport.update({
  id: '/qa',
  path: '/qa',
  getParentRoute: () => rootRouteImport,
} as any)
const ProvidersRoute = ProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsIndexRoute = PatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsPatientIdRoute = PatientsPatientIdRouteImport.update({
  id: '/patients/$patientId',
  path: '/patients/$patientId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/billing': typeof BillingRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/providers': typeof ProvidersRoute
  '/qa': typeof QaRoute
  '/referrals': typeof ReferralsRoute
  '/visits': typeof VisitsRoute
  '/patients/$patientId': typeof PatientsPatientIdRoute
  '/patients': typeof PatientsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/billing': typeof BillingRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/providers': typeof ProvidersRoute
  '/qa': typeof QaRoute
  '/referrals': typeof ReferralsRoute
  '/visits': typeof VisitsRoute
  '/patients/$patientId': typeof PatientsPatientIdRoute
  '/patients': typeof PatientsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/billing': typeof BillingRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/providers': typeof ProvidersRoute
  '/qa': typeof QaRoute
  '/referrals': typeof ReferralsRoute
  '/visits': typeof VisitsRoute
  '/patients/$patientId': typeof PatientsPatientIdRoute
  '/patients/': typeof PatientsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/billing'
    | '/dashboard'
    | '/login'
    | '/providers'
    | '/qa'
    | '/referrals'
    | '/visits'
    | '/patients/$patientId'
    | '/patients'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/billing'
    | '/dashboard'
    | '/login'
    | '/providers'
    | '/qa'
    | '/referrals'
    | '/visits'
    | '/patients/$patientId'
    | '/patients'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/billing'
    | '/dashboard'
    | '/login'
    | '/providers'
    | '/qa'
    | '/referrals'
    | '/visits'
    | '/patients/$patientId'
    | '/patients/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  BillingRoute: typeof BillingRoute
  DashboardRoute: typeof DashboardRoute
  LoginRoute: typeof LoginRoute
  ProvidersRoute: typeof ProvidersRoute
  QaRoute: typeof QaRoute
  ReferralsRoute: typeof ReferralsRoute
  VisitsRoute: typeof VisitsRoute
  PatientsPatientIdRoute: typeof PatientsPatientIdRoute
  PatientsIndexRoute: typeof PatientsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/visits': {
      id: '/visits'
      path: '/visits'
      fullPath: '/visits'
      preLoaderRoute: typeof VisitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals': {
      id: '/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ReferralsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa': {
      id: '/qa'
      path: '/qa'
      fullPath: '/qa'
      preLoaderRoute: typeof QaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/providers': {
      id: '/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof ProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/': {
      id: '/patients/'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof PatientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/$patientId': {
      id: '/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof PatientsPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  BillingRoute: BillingRoute,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  ProvidersRoute: ProvidersRoute,
  QaRoute: QaRoute,
  ReferralsRoute: ReferralsRoute,
  VisitsRoute: VisitsRoute,
  PatientsPatientIdRoute: PatientsPatientIdRoute,
  PatientsIndexRoute: PatientsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
